import React from 'react'
import clsx from 'clsx'

import { LABELS_CONFIGS } from './Label.constants'
import { LabelProps } from './Label.types'

import styles from './Label.module.scss'

export function Label({
  type,
  withoutText,
  large,
  title: passedTitle,
  className
}: LabelProps & { className?: string }) {
  const { title: configTitle, renderIcon, textColor, backgroundColor } = LABELS_CONFIGS[type]

  const title = passedTitle || configTitle
  const shouldNotRenderTitle = withoutText || !title

  return (
    <div className={clsx(styles.container, large && styles.large, className)} style={{ backgroundColor }}>
      {renderIcon ? renderIcon(large) : null}
      {!shouldNotRenderTitle && renderIcon ? (
        <span className={clsx(styles.iconTextSpacer, large && styles.large)} />
      ) : null}
      {shouldNotRenderTitle ? null : (
        <p
          style={{
            fontSize: large ? '12px' : '8.5px',
            lineHeight: large ? '15px' : '13px',
            margin: 0,
            color: textColor
          }}
        >
          {title}
        </p>
      )}
    </div>
  )
}
